import React from 'react';

const NotificationsTab = ({ slaAndAlerts }) => {
  return (
    <div className="flex-1 overflow-y-auto p-6">
      <div className="w-full">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Notification Settings</h2>
          
          <div className="space-y-6 pl-2">
            {/* SLA Settings */}
            <div className="grid grid-cols-3 gap-6">
              <div>
                <p className="text-sm text-gray-500 mb-2">SLA Response Time</p>
                <p className="text-base text-gray-900">
                  {slaAndAlerts.slaResponseTime ? `${slaAndAlerts.slaResponseTime} minutes` : 'N/A'}
                </p>
              </div>
              <div>
                <p className="text-sm text-gray-500 mb-2">SLA Uptime</p>
                <p className="text-base text-gray-900">
                  {slaAndAlerts.slaUptime ? `${slaAndAlerts.slaUptime}%` : 'N/A'}
                </p>
              </div>
            </div>

            {/* Teams Alerts */}
            {slaAndAlerts.Alerts && slaAndAlerts.Alerts.filter(a => a.AlertType === 'Teams').map((alert, index) => (
              <div key={alert.AlertId || index}>
                <div className="flex items-center gap-2 mb-2">
                  <p className="text-sm text-gray-500">Teams Channel</p>
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                    Teams
                  </span>
                </div>
                <p className="text-base text-gray-900">{alert.ChannelName || 'N/A'}</p>
                <p className="text-xs text-gray-500 mt-1">Webhook: {alert.WebhookLink || 'N/A'}</p>
              </div>
            ))}

            {/* Email Alerts */}
            {slaAndAlerts.Alerts && slaAndAlerts.Alerts.filter(a => a.AlertType === 'Email').map((alert, index) => (
              <div key={alert.AlertId || index}>
                <div className="flex items-center gap-2 mb-2">
                  <p className="text-sm text-gray-500">Email Recipients</p>
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                    Email
                  </span>
                </div>
                <p className="text-base text-gray-900">
                  {alert.Emails && alert.Emails.length > 0 
                    ? alert.Emails.join(', ') 
                    : 'N/A'}
                </p>
                <p className="text-xs text-gray-500 mt-1">Email recipients for DQ alerts</p>
              </div>
            ))}

            {/* No alerts message */}
            {(!slaAndAlerts.Alerts || slaAndAlerts.Alerts.length === 0) && (
              <div>
                <p className="text-sm text-gray-500 mb-2">Alerts</p>
                <p className="text-base text-gray-900">No alerts configured</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsTab;
